(function($) {

  var initializeBlock = function( $block ) {
    function matchHeightFire() {
      $('.iconItems .iconItem .iconItem-icon').matchHeight( {property: 'min-height'} );
      $('.iconItems .iconItem .iconItem-title').matchHeight( {property: 'min-height'} );
      $('.iconItems .iconItem .iconItem-text').matchHeight( {property: 'min-height'} );
    }
    matchHeightFire()

    $( window ).bind('resize orientationchange', function() {
      matchHeightFire();
    });

    setTimeout(function() {
      matchHeightFire();
    }, 1000)
  }

  $( document ).ready(function() {
    $('.block--icon-grid').each(function() {
      initializeBlock( $(this) );
    })
  })

  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=icon-grid', initializeBlock );
  }

})( jQuery );
